import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d952e78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "testimony-holder" }
const _hoisted_3 = {
  key: 0,
  class: "testimony-info"
}
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "review-holder-desktop" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stars" }, "⭐⭐⭐⭐⭐ 4.9", -1))
const _hoisted_9 = { class: "source" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-holder-mobile" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XyzTransition = _resolveComponent("XyzTransition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XyzTransition, { xyz: "fade left duration-3" }, {
        default: _withCtx(() => [
          ($setup.showSlider)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode($setup["AppChimp"], null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Testimony.chimp')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Testimony.title')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Testimony.subtitle')), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Testimony.review')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["testimony-list", $setup.showSlider?"natural":"grow"])
      }, [
        _createVNode($setup["HomeTestimonyCarousel"], { extendedCarousel: $setup.showSlider }, null, 8, ["extendedCarousel"]),
        _createVNode(_component_XyzTransition, { xyz: " small right " }, {
          default: _withCtx(() => [
            ($setup.showSlider)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "magic-button",
                  onClick: $setup.moveSlide
                }, [
                  _createVNode($setup["IconArrowLiteRight"], { class: "text-white" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2),
      _hoisted_10
    ])
  ]))
}